require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/fn/get-iterator.js
// module id = 1751
// module chunks = 0 4 5 6 7 8 10 11 13 17 18 19